"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('search_bar');
let showBtn = false;
const SearchBar = (props) => {
    const { value, placeholder, onInput, onClear, onFocus, onBlur, onActionClick, onSubmit, inputStyle, shape, type = 'text', confirmType = 'search', style, focus, actionName = '取消', keepShowActionButton, hideActionButton, size, } = props;
    const [isFocus, setIsFocus] = react_1.useState(false);
    const handleFocus = (e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        setIsFocus(true);
    };
    const handleBlur = (e) => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        setIsFocus(false);
    };
    const handleInput = (e) => {
        onInput === null || onInput === void 0 ? void 0 : onInput(e.target.value);
    };
    const handleClear = () => {
        onClear === null || onClear === void 0 ? void 0 : onClear(value);
    };
    const handleActionClick = () => {
        showBtn = false;
        onActionClick === null || onActionClick === void 0 ? void 0 : onActionClick();
    };
    const handleConfirm = (e) => {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(e.target.value);
    };
    const active = isFocus || value || focus;
    if (active && !showBtn) {
        showBtn = true;
    }
    let iconSize = '32px';
    if (size === 'large') {
        iconSize = '36px';
    }
    if (size === 'small') {
        iconSize = '28px';
    }
    return (React.createElement(one_1.View, { className: classnames_1.default({
            [prefixCls]: true,
            [`${prefixCls}-large`]: size === 'large',
            [`${prefixCls}-small`]: size === 'small',
        }), style: style },
        React.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-input`, { [`${prefixCls}-input-${shape}`]: shape }), style: inputStyle },
            React.createElement(one_1.View, { className: classnames_1.default({
                    [`${prefixCls}-input-synthetic`]: true,
                    [`${prefixCls}-input-is_left`]: active,
                }) },
                React.createElement(one_1.View, { className: `${prefixCls}-input-synthetic-icon` },
                    React.createElement(icon_1.default, { type: "search", size: iconSize, color: "#999" })),
                React.createElement(one_1.View, { className: `${prefixCls}-input-synthetic-placeholder`, style: {
                        visibility: active ? 'hidden' : 'visible',
                    } }, placeholder)),
            React.createElement(one_1.Input, { className: `${prefixCls}-input-value`, 
                // @ts-ignore
                type: type, confirmType: confirmType, value: value, onFocus: handleFocus, onBlur: handleBlur, onInput: handleInput, onConfirm: handleConfirm, focus: focus }),
            React.createElement(one_1.View, { className: `${prefixCls}-input-clear`, onTap: handleClear },
                React.createElement(icon_1.default, { type: "roundclosefill", size: `${iconSize}px`, color: "#999", style: {
                        visibility: value ? 'visible' : 'hidden',
                    } }))),
        !hideActionButton ? (React.createElement(one_1.View, { className: classnames_1.default({
                [`${prefixCls}-action_button`]: true,
                [`${prefixCls}-show_action_button`]: keepShowActionButton ? true : active,
            }), onTap: handleActionClick }, actionName)) : null));
};
exports.default = SearchBar;
